//This is for POS Print

import React from "react";
import "../../stylePos.css";
import { useSelector } from "react-redux";
import { company } from "titum-custom/details";
import BillHeader from "Components/Print/billHeaderPos";
import { bottomNavigationActionClasses } from "@mui/material";
import { VerticalAlignBottom } from "@mui/icons-material";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { currency } from "Components/MUI_components/currencyFormatterTag";

const PrintBill = React.forwardRef((props, ref) => {
  const { code, date } = useSelector((state) => state.lastInsertInvoice);
  const printedDate = date ? new Date(date) : new Date();
  const { returnData } = props;
  const {customer,stockHistories} = returnData;

  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };
  
  return (

    <div className ref={ref}>

      <div className="billBody" >
        <BillHeader />

        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>{company.address}</div>
          <div style={{ textAlign: "center", fontSize: 12 }} >TEL: {company.phone} / {company.phone2} </div>
        </div>

        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }} ></div>

        <div >
          <div className="flex" >
            <strong style={{ fontSize: 13 }}>To: </strong>&nbsp;
            <strong style={{ fontSize: 13 }}> {customer?.firstName ? customer.firstName : "Cash"}</strong>
          </div>
          <div className="flex" >
            <strong style={{ fontSize: 13 }}>{customer && customer.customerAddresses.map((row) => (row.address ? row.address : ""))}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 13 }}>  {customer && customer.customerAddresses.map((row) => (row.city ? row.city : "-"))}</strong>
          </div>
          <div className="flex" >
            <strong style={{ fontSize: 13 }}>   {customer && customer.customerAddresses.map((row) => (row.phone2 ? row.phone2 : ''))}
              {customer && customer.customerAddresses.map((row) => (
                row.phone1 ? ' / ' + row.phone1 : ''))}</strong>
          </div>


          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.DATE}: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{printedDate.toLocaleString()}</strong>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>

        <table className="print-table-pos">
          <thead className="thead">
          <th>#</th>
              <th width="80%">DEC</th>
              <th align="right" style={{ paddingLeft: 10 }}>QTY</th>
              <th align="right" style={{ paddingLeft: 10 }}>PRI </th>
              <th align="right" style={{ paddingLeft: 10 }}>D.%</th>
              <th align="right" style={{ paddingLeft: 10 }}> D.Rs</th>
              <th align="right" style={{ paddingLeft: 10 }}>AMT</th>
          </thead>

          <tbody>
          {stockHistories
              .filter(i => i.quantity > 0)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td> {index + 1}.</td>
                    <td colSpan="5">
                    {row.name ? row.name : row.itemMaster.name }

                    </td>
                  </tr>
                  <tr>
                    <td align="right" colSpan="3">{parseFloat(row.quantity)}</td>
                    <td align="center" style={{ paddingLeft: 10 }}>{row.costPrice}</td>
                    <td align="center" style={{ paddingLeft: 10 }}>{row.discountPercentage}</td>
                    <td align="center" style={{ paddingLeft: 10 }}>{row.discountAmount}</td>
                    <td align="right">
                      <strong>{currency(handleLineTotal(
                        row.quantity,
                        row.retailPrice,
                        row.discountPercentage,
                        row.discountAmount
                      ))}</strong>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>


        </table>

        <div style={{ borderBottom: "1px solid #000" }}></div>
        
        <div
          className="flex-print  mb  justify-content-spaceBetween"
          style={{ borderTop: "1px solid #000" }}
        >
          <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.LAST_TOTAL} :</strong>

          <strong style={{ fontSize: 16 }}>{currency(returnData.totalAmount)}</strong>
        </div>

     

        <div style={{ borderBottom: "1px solid #000" }}></div>

        {/* PRINT WITH BIZX FOOTER */}
        {/* <small className="mt  text-center" >

          <div style={{ fontSize: 11 }} >
            ITEMS PURCHASED WILL NOT BE RETURNED OR EXCHANCED AFTER 14 DAYS & ELECTRICAL ITEMS WILL NOT BE ACCEPTED.<br />
            **CASH WILL NOT BE REFUNDED**<br />
            CREDIT BILLS SHOULD BE SETTLED  WITHIN 30 DAYS FROM THE DATE OF ISSUE.<br />
            THANK YOU COME AGAIN <br />
            SOLUTION BY TITUM (PVT) LTD <br />
            {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}

          </div>
        </small> */}
      </div>

    </div>
  )
});

export default PrintBill;

// mt-margin top mb-marigin bottom
// justify-content-spaceBetween - vertical space
// #000 - black